import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { Timestamp } from '@mi-front/core';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';

export function DiarizationPlayBtn(p: { time: Timestamp }) {
  const { $t } = useIntl();
  const play = usePlaybackPlay();

  const handlePlay = () => {
    play({
      startTs: p.time,
    });
  };

  return (
    <Button size="small" sx={{ marginTop: 0.5 }} onClick={handlePlay}>
      {$t({
        id: 'common.play',
        defaultMessage: 'Reproducir',
      })}
    </Button>
  );
}
